import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

const route: AppRouteModule = {
  /**
   * 'make-sample': '打样相关',
   */
  path: '/make-sample',
  name: 'AboutSample',
  component: LAYOUT,
  redirect: '/make-sample/make-sample-order',
  meta: {
    icon: 'mingcute:certificate-line',
    title: t('routes.make-sample.make-sample'),
    orderNo: 10100,
    roles: [20222082],
  },
  children: [
    /**
     * 'make-sample-order': '查询打样订单',
     */
    {
      path: 'make-sample-order',
      name: 'MakeSampleOrder',
      component: () => import('/@/views/make-sample/make-sample-order/index.vue'),
      meta: {
        title: t('routes.make-sample.make-sample-order'),
        roles: [20222083],
      },
    },
  ],
};

export default route;
